import { VideoJsPlayerOptions } from 'video.js';

export const defaultVideoType = 'application/x-mpegURL';
export const defaultPlaybackRates = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
export const defaultVideoTrackKind = 'captions';
export const defaultVideoTrackLanguage = 'en';

export const defaultPlayerOptionsProps: VideoJsPlayerOptions = {
  controls: true,
  playbackRates: defaultPlaybackRates,
  fluid: true,
  html5: {
    nativeTextTracks: false,
    vhs: {
      overrideNative: true,
      useBandwidthFromLocalStorage: true,
    },
  },
  controlBar: {
    pictureInPictureToggle: false,
    subsCapsButton: true,
    playbackRateMenuButton: true,
  },
  responsive: true,
};
